module.exports = __webpack_public_path__ + "static/media/spid-idp-infocertid~bmqXPBOx.ec5b92ef.svg";